import React, { useState,useEffect } from "react";
import { useParams,useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";
import { ResponsiveRadar } from '@nivo/radar';
import LoadingIndicatorThreeDots from "../../components/popups/LoadingIndicatorThreeDots";
import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import makePDF from '../../components/common/makePDF';
import { ChangeSimpleDateString,PassedMonths,GetChildrenState, unescapeHtml } from "../../components/common/Common";
import "../../css/style.css";
import pdfIcon from "../../img/pdf-download.png";

let varOptions = [
  {
      anchor: 'top-left',
      direction: 'column',
      translateX: -50,
      translateY: -40,
      itemWidth: 80,
      itemHeight: 20,
      itemTextColor: '#999',
      symbolSize: 12,
      symbolShape: 'circle',
      effects: [
          {
              on: 'hover',
              style: {
                  itemTextColor: '#000'
              }
          }
      ]
  }
];

//보강수업설정
const MamaMonteView = () => {
  const { clc_idx } = useParams();
  const navigate = useNavigate();
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);
  const pdf = makePDF();
  const [varClassChildrenInfo,setClassChildrenInfo] = useState({}); //원생/클라스 정보

  const [varDevelopmentList,setDevelopmentList] = useState([]); //발달목표
  const [varActivityList,setActivityList] = useState([]); //활동목표
  const [varAdvanceInfo,setAdvanceInfo] = useState({}); //결과
  const [varEvaluationData,setEvaluationData] = useState([]); //그래프 정보
  const [varResultList,setResultList] = useState([]); //결과

  //평가할 원생/클래스정보 호출
  const GetEvaluationList = async() => {
    const sendData = {clc_idx:clc_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_childrens_mamamonte`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const childrenInfo = datas.results[0];
        setClassChildrenInfo(childrenInfo);
  
        //발달목표/활동목표
        const studys = datas.studys;
        const themes = studys.find(el=>el.vt_idx===childrenInfo.ev_vt_idx);

        //발달목표
        const developArray = themes.vt_character.split('|');
        setDevelopmentList(developArray);
        //활동목표
        const activityArray = themes.vt_goals.split('|');
        setActivityList(activityArray);
        //해당 시기 표준 발달 사항
        setAdvanceInfo(themes);
        //평가 결과 정보 읽기
        GetEvaluationInformation(childrenInfo.clc_ev_idx,themes.vt_idx,childrenInfo);
      }
    });
  }

  //평가 결과 정보 읽기
  const GetEvaluationInformation = async(ev_idx,vt_idx,childrenInfo) => {
    const sendData = {ev_idx:ev_idx,vt_idx:vt_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_evaluation_mamamonte_options`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const evaluationList = datas.evaluationList;
        const scores = datas.scores;
        let resultArray = [];
        let graphArray = [];
        for(var i=0; i<evaluationList.length; i++) {
          let evaluation = evaluationList[i];
          let totalscore = evaluation.totalscore;
          let scoreList = scores.filter(el=>el.vts_idx === evaluation.vts_idx);
          let vtr_result = '';
          for(var j=0; j<scoreList.length; j++) {
            let scoreData = scoreList[j];
            if(totalscore >= scoreData.vtr_score) {
              vtr_result = scoreData.vtr_result;
              break;
            }
          }
          let items = {name:evaluation.vts_name,score:totalscore,desc:vtr_result};
          resultArray.push(items);

          if(i >= evaluationList.length-1) continue;
          let score = totalscore / 9 * 100;
          //let newData = {'taste': evaluation.vts_name,'표준5':60,[childrenInfo.ch_name]:score,'전체9':100};
          let newData = {'taste': evaluation.vts_name,'표준(5)':60,"원생":score,'전체(9)':100};
          graphArray.push(newData);
        }
        setEvaluationData(graphArray);
        setResultList(resultArray);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    GetEvaluationList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //수정 페이지
  const onLinkPageHandler = (e,clc_idx) => {
    navigate(`/Branch/MamaMonteDetail/${clc_idx}`);
  }
  
  //PDF 다운로드
  const [promiseInProgress,setPromiseInProgress] = useState(false);
  const onDownloadPDFHandler = async(e) => {
    if(!window.confirm('MDT 발달 진도표를 PDF로 저장합니까?')) return false;
    e.preventDefault();

    const noshow1Box = document.querySelector('.btn-yes');
    const noshow2Box = document.querySelector('.pdf-downloader');
    noshow1Box.setAttribute('style','display:none');
    noshow2Box.setAttribute('style','display:none');
    await pdf.viewWithPDF('mdt-con',1,setPromiseInProgress)
    noshow1Box.setAttribute('style','display:block');
    noshow2Box.setAttribute('style','display:block');
  }

  return (
    <div className="vh-content">
      <HeaderBranchTitle varPageTitle={'MDT 발달 진도표'} varBackString={'/Branch/AnalysisSet'}/>
      <div className="vh-content-body ct-mdt-wrap" style={{marginTop:"60px"}}>
        <div className="mdt-con">
          <div className="center-wrap">
            <div className="mdt-info">
							<div className="line">
								<div className="name">{varClassChildrenInfo.ch_name} {PassedMonths(varClassChildrenInfo.ch_birthday)}개월</div>
								<div>{ChangeSimpleDateString(varClassChildrenInfo.ch_birthday)} ({GetChildrenState(varClassChildrenInfo.ch_status)})</div>
							</div>
							<ul className="mdt-txt">
								<li>
									<p>학기명</p>
									<div>{varClassChildrenInfo.sm_name}</div>
								</li>
								<li>
									<p>클래스</p>
									<div>{varClassChildrenInfo.cl_name}</div>
								</li>
								<li>
									<p>차수</p>
									<div>{varClassChildrenInfo.clc_cnts}/{varClassChildrenInfo.cl_studys}</div>
								</li>
                <li>
									<p>평가일</p>
									<div>{ChangeSimpleDateString(varClassChildrenInfo.clc_adate)}</div>
								</li>
                {varClassChildrenInfo.clc_ev_idx>0 && <div className="pdf-downloader" onClick={e=>onDownloadPDFHandler(e)}><img src={pdfIcon} alt=""/></div>}	
							</ul>
						</div>
            <button className="btn-yes" onClick={e=>onLinkPageHandler(e,varClassChildrenInfo.clc_idx)}>수정</button>
            {/* 발달 목표 */}
						<div className="mdt-box">
              <p className="mdt-tit">해당 시기 마마몽떼 발달 목표</p>
              <div className="txt-wrap">
                <div className="txt-box">
                  <p className="mdt-label">발달 특징</p>
                  <ul>
                    {varDevelopmentList.map((develops,i)=>(
                      <li key={'develops_'+i}>- {develops}</li>
                    ))}
                  </ul>
                </div>
                <div className="txt-box">
                  <p className="mdt-label">활동 목표</p>
                  <ul>
                    {varActivityList.map((activitys,i)=>(
                      <li key={'activitys_'+i}>- {activitys}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            {/* 발달 영역표 */}
            <div className="mdt-box">
              <p className="mdt-tit">발달 영역표</p>
              <div className="graph-wrap">
                <ResponsiveRadar
                  animate={false}
                  data={varEvaluationData}
                  keys={[ "표준(5)","원생","전체(9)" ]}
                  indexBy="taste"
                  valueFormat=">-.2f"
                  margin={{ top: 50, right: 30, bottom: 40, left: 60 }}
                  borderColor={{ from: 'color' }}
                  gridLabelOffset={10}
                  dotSize={5}
                  dotColor={{ theme: 'background' }}
                  dotBorderWidth={2}
                  colors={{ scheme: 'nivo' }}
                  blendMode="multiply"
                  motionConfig="wobbly"
                  legends={varOptions}
              />
              </div>
            </div>
            {/* 발달 영역 진단 */}
            <div className="mdt-box">
              <p className="mdt-tit">발달 영역 진단</p>
              {varResultList.map((results,i)=>(
                <div key={'results_'+i} className="result-box">
                  <div className="line">
                    <p className="mdt-comment-title">{results.name}</p>
                    <div className="mdt-comment-num">{results.score} / 표준 지수 5</div>
                  </div>
                  <div className="mdt-comment-desc">{unescapeHtml(results.desc)}</div>
                </div>
              ))}
            </div>
            {/* 해당 시기 표준 발달 사항 */}
            <div className="mdt-box">
              <p className="mdt-tit">해당 시기 표준 발달 사항</p>
              <div className="result-box">
                <div className="line"><p className="mdt-comment-title">대근육</p></div>
                <div className="mdt-comment-desc">{unescapeHtml(varAdvanceInfo.vt_result1)}</div>
              </div>
              <div className="result-box">
                <div className="line"><p className="mdt-comment-title">소근육</p></div>
                <div className="mdt-comment-desc">{unescapeHtml(varAdvanceInfo.vt_result2)}</div>
              </div>
              <div className="result-box">
                <div className="line"><p className="mdt-comment-title">인지</p></div>
                <div className="mdt-comment-desc">{unescapeHtml(varAdvanceInfo.vt_result3)}</div>
              </div>
              <div className="result-box">
                <div className="line"><p className="mdt-comment-title">언어</p></div>
                <div className="mdt-comment-desc">{unescapeHtml(varAdvanceInfo.vt_result4)}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LoadingIndicatorThreeDots promiseInProgress={promiseInProgress}/>
    </div>	
  );
}
export default MamaMonteView;